import React from "react";
import { useLoadScript } from "@react-google-maps/api";
import Head from "next/head";
import "react-datepicker/dist/react-datepicker.css";

import GetQuotesMain from "@/components/get-quotes/get-quotes-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { googleMapsApiKey } from "@/utils/constants";

const GetQuote = () => {
  // INFO keep the form hidden till google maps api is loaded
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey || "",
    libraries: ["places"],
  });

  return (
    <>
      <Head>
        <title>{seoData.GET_INSTANT_QUOTE.title}</title>
        <SeoMetaData data={seoData.GET_INSTANT_QUOTE} />
      </Head>

      {isLoaded && <GetQuotesMain />}
    </>
  );
};

export default GetQuote;
